import { useMutation, useQuery } from '@tanstack/react-query';
import {
  configDownloadSchedule,
  deleteDownloadSchedule,
  getDownloadScheduleDetail,
} from 'services/reporting';
import { getFTPconfig, validateFTPConfig } from 'services/user';
export const getKeyFactPanels = (id) => {
  return ['reporting', 'get-download-schedule-detail', parseInt(id)];
};
export const getKeyFTPConfig = (id) => {
  return ['reporting', 'get-ftp-config', parseInt(id)];
};
export const useGetDownloadScheduleDetail = ({ id, enabled }) => {
  const { data, ...restQuery } = useQuery({
    queryKey: getKeyFactPanels(id),
    queryFn: async () => {
      const { data } = await getDownloadScheduleDetail({ reportId: +id });
      return data || {};
    },
    enabled: enabled,
  });
  return {
    downloadScheduleDetail: data || {},
    ...restQuery,
  };
};
export const useGetFTPConfig = ({ id, ...resProps }) => {
  const { data, ...restQuery } = useQuery({
    queryKey: getKeyFTPConfig(id),
    queryFn: async () => {
      const { data } = await getFTPconfig();
      return data || {};
    },
    ...resProps,
  });
  return {
    FTPConfig: data || {},
    ...restQuery,
  };
};
export const useMutationFTPConfig = () => {
  const validateFTP = useMutation({
    mutationFn: validateFTPConfig,
  });
  return {
    validateFTP,
  };
};
export const useMutationDownloadSChedule = () => {
  const deleteSchedule = useMutation({
    mutationFn: deleteDownloadSchedule,
  });
  const configSchedule = useMutation({
    mutationFn: configDownloadSchedule,
  });
  return {
    deleteSchedule,
    configSchedule,
  };
};
